// Texts of the ERP area "support" (wiki and the tickets of every institution; the tickets themselves live in finance.ts).
export default {
  wiki: {
    title: 'Wiki',
    subtitle: 'Base de conhecimento interna: processos, acessos, políticas.',
    new: 'Novo artigo',
    categoriesButton: 'Categorias',
    searchPlaceholder: 'Buscar no título e no conteúdo',
    filterCategory: 'Categoria',
    viewLabel: 'Visualização',
    viewCards: 'Cartões',
    viewList: 'Lista',
    emptyTitle: 'Nenhum artigo',
    emptyText: 'Escreva o primeiro artigo da wiki.',
    updated: 'Atualizado em {date} por {name}',
    updatedNoName: 'Atualizado em {date}',
    attachments: 'Nenhum anexo | 1 anexo | {count} anexos',
    columns: { title: 'Título', category: 'Categoria', attachments: 'Anexos', updated: 'Atualizado' },
    dialogNew: 'Novo artigo',
    dialogEdit: 'Editar artigo',
    fields: { title: 'Título', category: 'Categoria', content: 'Conteúdo' },
    newCategoryOption: '+ Nova categoria…',
    noContent: 'Sem conteúdo.',
    attachmentsTitle: 'Anexos',
    noAttachments: 'Nenhum anexo.',
    drop: 'Arraste arquivos ou clique para escolher',
    dropHint: 'Até 8 MB por arquivo.',
    pending: 'Serão enviados ao salvar: {names}',
    removeAttachment: 'Remover anexo',
    removeAttachmentNamed: 'Remover o anexo {name}',
    keepAttachment: 'Manter',
    removingOnSave: '1 anexo será removido ao salvar | {n} anexos serão removidos ao salvar',
    by: 'Criado por {name}',
    categories: {
      title: 'Categorias da wiki',
      empty: 'Nenhuma categoria.',
      name: 'Nome',
      color: 'Cor',
      add: 'Adicionar',
      save: 'Salvar',
      edit: 'Editar categoria',
      count: 'Nenhum artigo | 1 artigo | {count} artigos',
      newTitle: 'Nova categoria',
    },
  },
  // Chamados de todas as instituições (equipe da plataforma; só leitura).
  monitor: {
    title: 'Chamados das instituições',
    subtitle: 'Os chamados de todas as instituições com o módulo de chamados, num só lugar. Somente leitura.',
    allTenants: 'Todas as instituições',
    tenantOption: '{name} ({count} em aberto)',
    scopeLabel: 'Situação',
    scope: { open: 'Em aberto', all: 'Todos, inclusive encerrados' },
    columns: { tenant: 'Instituição', access: 'Seu acesso' },
    access: { edit: 'Pode atender', view: 'Só consulta', none: 'Sem acesso' },
    byCustomer: 'Pelo cliente',
    noResponsible: 'Sem responsável',
    emptyTitle: 'Nenhum chamado',
    emptyText: 'Nenhum chamado com esses filtros nas instituições acompanhadas.',
    noAccessTitle: 'Sem acesso aos chamados de {name}',
    noAccessText: 'Ver a lista não dá acesso à instituição. Peça a um administrador dela um papel com permissão nos chamados.',
    hint: 'O chamado abre no endereço da instituição, com o seu acesso lá. Detalhes, contatos e o histórico só aparecem para quem tem permissão na instituição.',
  },
}
